import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    ProviderId} from "@@/shared/providers/provider-id";
import {
    providerIdZodSchema,
} from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { AccountingData} from "../accounting-data";
import { accountingDataZodSchema } from "../accounting-data";

type DownloadSieFileCommand = {
    readonly _id: string;
    readonly _type: "DOWNLOAD_SIE_FILE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly providerId: ProviderId;
    readonly from: IsoAndUnixTimestamp;
    readonly to: IsoAndUnixTimestamp;
    readonly accountingData: AccountingData;
};

type FactoryParams = Except<
    DownloadSieFileCommand,
    "_id" | "_type" | "_createdAt"
>;
const downloadSieFileCommandFactory = (params: FactoryParams) => {
    const command: DownloadSieFileCommand = {
        ...params,
        _id: generateId({ prefix: "download_sie_file_command__" }),
        _type: "DOWNLOAD_SIE_FILE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const downloadSieFileCommandZodSchema: z.ZodSchema<DownloadSieFileCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("DOWNLOAD_SIE_FILE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        providerId: providerIdZodSchema,
        from: isoAndUnixZodSchema,
        to: isoAndUnixZodSchema,
        accountingData: accountingDataZodSchema,
    });

export { downloadSieFileCommandFactory, downloadSieFileCommandZodSchema };
export type {
    DownloadSieFileCommand,
    FactoryParams as DownloadSieFileCommandParams,
};
